export const CONTENT_API_ENDPOINTS = {
  NEWS_CATEGORIES: "/article-category",
  NEWS_LIST: "/articles",
  NEWS_DETAIL: "/articles/details",
  POLICY_DETAIL: "/page/details",
  POLICY_LIST: "/pages/policies",
} as const;

export const CONTENT_MOCK_DELAYS = {
  newsList: 420,
  newsLatest: 240,
  policyDetail: 320,
  policyFooter: 180,
} as const;

export const NEWS_PAGE_SIZE = 6;
export const DEFAULT_SHARE_IMAGE_PATH = "/home/ancarat-gold.jpg";

export const NEWS_QUERY_PARAMS = {
  CATEGORY: "category",
  PAGE: "page",
} as const;
